import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { clientPath, projectPath } from '@/api/clients.ts';
import { useListAllProjects, useListClients } from '@/api/generated/clients.ts';
import { useWorkspacePath } from '@/api/workspaces.ts';
import Breadcrumbs from '@/core/components/Breadcrumbs.tsx';

// The client's and the project's names, found by the slugs in the URL; the slug while there's none.
export const ClientCrumb = () => {
    const { clientSlug } = useParams();
    const clients = useListClients();

    if (!clients.data) return null;
    return <>{clients.data.find((client) => client.slug === clientSlug)?.name ?? clientSlug}</>;
};

export const ProjectCrumb = () => {
    const { projectSlug } = useParams();
    const projects = useListAllProjects();

    if (!projects.data) return null;
    return <>{projects.data.find((project) => project.slug === projectSlug)?.name ?? projectSlug}</>;
};

interface Placed {
    client: { slug: string; name: string } | null;
    project: { slug: string; name: string } | null;
}

// Before a recap's or a source's own crumb: Projekte and its project while it has one, else Kunden and its client
// while it has one (plan/DECISIONS.md D129, D185), else its own section.
export const PlaceCrumbs = ({ item, navKey }: { item: Placed; navKey: 'recaps' | 'sources' }) => {
    const { t } = useTranslation();
    const workspacePath = useWorkspacePath();
    const { client, project } = item;

    if (project) {
        return (
            <>
                <Breadcrumbs.Item href={workspacePath('/projects')}>{t('nav.projects')}</Breadcrumbs.Item>
                <Breadcrumbs.Item href={workspacePath(projectPath(project))}>{project.name}</Breadcrumbs.Item>
            </>
        );
    }
    if (!client) return <Breadcrumbs.Item href={workspacePath(`/${navKey}`)}>{t(`nav.${navKey}`)}</Breadcrumbs.Item>;
    return (
        <>
            <Breadcrumbs.Item href={workspacePath('/clients')}>{t('nav.clients')}</Breadcrumbs.Item>
            <Breadcrumbs.Item href={workspacePath(clientPath(client))}>{client.name}</Breadcrumbs.Item>
        </>
    );
};
